import useTheme from '@/theme/useTheme';
import { formatMoneyByCurrency } from '@/utils';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import React from 'react';
import prizeIImage from './assets/prize.png';
import prizeIIImage from './assets/prizeII.png';
import prizeIIIImage from './assets/prizeIII.png';
import prizeVoncherImage from './assets/prizeVoucher.png';
import prizeVoncher2Image from './assets/prizeVoucher2.png';
import { GradientBox, PrizeDisplayItemWrapper } from './styled';

const RewardsDisplay: React.FC<{
  drawRewards: any[];
}> = ({ drawRewards }) => {
  const { t } = useTranslation();

  const { theme } = useTheme();

  return (
    <>
      <Stack mt={4} gap={2}>
        <Stack
          direction={'row'}
          gap={2}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Typography variant="h4" fontWeight={500}>
            {t('moon-draw::Available Prizes')}
          </Typography>
        </Stack>
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          gap={2}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
          }}
        >
          {drawRewards.map((reward, index) => (
            <GradientBox key={index}>
              <PrizeDisplayItemWrapper
                alignItems={'center'}
                sx={{
                  ['img.reward-bg']: {
                    aspectRatio: reward.amount >= 199 ? '1/1' : '2.41/1',
                    height: 'auto',
                    transform:
                      reward.amount >= 199 ? undefined : 'rotate(-15deg)',
                    width: reward.amount >= 199 ? undefined : '80%',
                    position: 'absolute',
                    opacity: 0.5,
                    bottom: reward.amount >= 199 ? undefined : 0,
                    left: reward.amount >= 199 ? undefined : '30%',
                    [theme.breakpoints.down('sm')]: {
                      left: 'unset',
                      bottom: reward.amount >= 199 ? undefined : '15%',
                      width: reward.amount >= 199 ? undefined : '60%',
                    },
                  },
                  ['>h6, >p']: {
                    lineHeight: 1.2,
                  },
                }}
              >
                <Typography
                  variant={'h6'}
                  textAlign={'start'}
                  width={'100%'}
                  position={'relative'}
                  zIndex={1}
                >
                  {reward.chancePercentage.toFixed(4)}%
                </Typography>

                <Typography
                  width={'100%'}
                  textAlign={'start'}
                  fontWeight={700}
                  fontSize={(theme) => theme.typography.pxToRem(32)}
                  color={(theme) =>
                    reward.amount >= 199
                      ? theme.palette.primary.main
                      : undefined
                  }
                  position={'relative'}
                  zIndex={1}
                >
                  {formatMoneyByCurrency(reward.amount, {
                    withCurrencySymbol: true,
                    decimal: 2,
                  })}
                </Typography>
                <Image
                  className="reward-bg"
                  src={
                    reward.amount === 999
                      ? prizeIImage
                      : reward.amount === 499
                        ? prizeIIImage
                        : reward.amount === 199
                          ? prizeIIIImage
                          : reward.amount >= 1.8
                            ? prizeVoncherImage
                            : prizeVoncher2Image
                  }
                  alt="prize"
                ></Image>
                <Typography
                  width={'100%'}
                  textAlign={'start'}
                  color={(theme) => theme.palette.text.secondary}
                  position={'relative'}
                  zIndex={1}
                >
                  {reward.name}
                </Typography>
              </PrizeDisplayItemWrapper>
            </GradientBox>
          ))}
        </Stack>
        {/* Add your rewards display content here */}
      </Stack>
    </>
  );
};

export default RewardsDisplay;
